import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DeviceParameterState {
  isLoading: boolean
  error: string | undefined
  data: any | null
  httpStatus: number | undefined
}

export const initialState: DeviceParameterState = {
  isLoading: false,
  error: undefined,
  data: null,
  httpStatus: 0
}

const addDeviceParameterSlice = createSlice({
  name: 'AddDeviceParameterSlice',
  initialState,
  reducers: {
    addDeviceParameterLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: null,
        httpStatus: 0
      }
    },
    addDeviceParameterUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    addDeviceParameterErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  addDeviceParameterLoadingAction,
  addDeviceParameterUpdateAction,
  addDeviceParameterErrorAction
} = addDeviceParameterSlice.actions

export default addDeviceParameterSlice.reducer
